import React from 'react';
import { Redirect, Route } from 'react-router-dom';

import { useAuth } from '../../context/AuthContext';
import AuthLayout from '../../components/Layout/AuthLayout';

type Props = {
  children: React.ReactElement;
  [key: string]: any;
};

export const AdminRoute = ({ children, ...rest }: Props) => {
  const { authState } = useAuth();
  return (
    <Route
      {...rest}
      render={(location) =>
        authState.isAuthenticated && authState?.userInfo?.isAdmin ? (
          <AuthLayout>{children}</AuthLayout>
        ) : (
          <Redirect
            to={{
              pathname: '/',
              state: { from: location }
            }}
          />
        )
      }
    />
  );
};
